import type { ReactNode } from 'react';
import { Icon, Typography } from '@timeedit/ui-components';
import {
  Button,
  Divider,
  List,
  Popconfirm,
  Tooltip,
} from '@timeedit/ui-components/antd';
import intl from '../../../i18n/intl';
import './index.scss';

type Props = {
  data: TListValues[] | undefined;
  onSelect: (id: any) => void;
  onDelete?: (id: any) => void;
  onCopy?: (id: any) => void;
  selectedItemId: any;
  isLoading?: boolean;
};

type TListValues = {
  value: string | number;
  listLabel: string | ReactNode;
  fieldType?: string;
};

const language: any = intl.messages;

const DefaultListView = ({
  data,
  onSelect,
  onDelete,
  onCopy,
  selectedItemId,
  isLoading = false,
}: Props) => {
  return (
    <List
      loading={isLoading}
      itemLayout="horizontal"
      dataSource={data}
      renderItem={(item) => (
        <div
          key={`${item.value}`}
          className={`list-item-wrapper ${
            item.value &&
            selectedItemId &&
            item.value.toString() === selectedItemId.toString()
              ? 'selected-item'
              : ''
          } ${
            item.value === 0 || item.value === 'new' ? 'not-saved-item' : ''
          }`}
          onClick={() => onSelect(item.value)}
        >
          <Tooltip title={item.listLabel} placement={'left'}>
            <Typography.Text size="small" style={{ width: '100%' }}>
              {item.listLabel}
            </Typography.Text>
          </Tooltip>
          <Tooltip title={language.copy} placement="topLeft" key={item.value}>
            <Button
              size="small"
              type="text"
              icon={<Icon id="CopyOutlined" alt="Copy" />}
              onClick={(e) => {
                e.stopPropagation();
                !!onCopy && onCopy(item.value);
              }}
            />
          </Tooltip>
          <Popconfirm
            key={item.value}
            title={`${language.sure_to_delete_object}?`}
            onConfirm={(e) => {
              e?.stopPropagation();
              !!onDelete && onDelete(item.value);
            }}
            okText={language.yes}
            cancelText={language.no}
          >
            <Button
              size="small"
              danger
              ghost
              type="text"
              className={`list-item-action-button ${
                !onDelete ? 'not-visible' : ''
              }`}
              icon={<Icon id="DeleteOutlined" alt="Delete" />}
            />
          </Popconfirm>
        </div>
      )}
    />
  );
};

export default DefaultListView;
